/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCategoryPlus = createReactComponent("category-plus", "IconCategoryPlus", [
  [
    "path",
    {
      d: "M4 4h6v6h-6zm10 0h6v6h-6zm-10 10h6v6h-6zm10 3h6m-3 -3v6",
      key: "svg-0"
    }
  ]
]);

export { IconCategoryPlus as default };
//# sourceMappingURL=IconCategoryPlus.js.map
